export default {
  inputState: {},

  itemInfo: {},

  isLoading: false,

  quantity: (localStorage.getItem('oders.quantity')) 
      ? parseInt(localStorage.getItem('oders.quantity'))
      : 0,

  unitList: ["Cái", "Chiếc", "Bộ", "Đôi"],

  variationId: '',
  
  brandList: [
    "Addidas",
    "An Phước",
    "Bella Moda",
    "Biluxury",
    "Boran",
    "Canifa",
    "Chic-Land",
    "Cocosin",
    "Elise",
    "Elpis",
    "Eva de Eva",
    "Funda",
    "HM",
    "HNOSS",
    "Ivy Moda",
    "Juno",
    "K&K Fashion",
    "Lacoste",
    "Lane Jt",
    "M2",
    "May",
    "Merriman",
    "NEM",
    "Ninomaxx",
    "Novelty",
    "Owen",
    "PT2000",
    "SEA Collection",
    "Seven AM",
    "The Blue Exchange",
    "Top4man",
    "Uniqlo",
    "Việt Tiến",
    "Zara"
  ]
};
